module.exports = "pegasus_template/assets/round-knob.png";